import * as React from 'react'
import { createContext } from 'use-context-selector'
import { useAppContextState } from 'app/@hooks'

const Context = createContext({})

export function PackagesDetailsDrawerProvider ({children}) {
    const { state, updateState, resetState } = useAppContextState({})

    return <Context.Provider value={{ state, updateState, resetState }}>
        {children}
    </Context.Provider>
}

export default Context